import { ReactNode } from 'react';
import { joinNames } from '../helpers';
import css from './TwoColContainer.module.scss';

type TwoColContainerProps = React.TableHTMLAttributes<HTMLTableElement>;

export function TwoColContainer({ className, children, ...attr }: TwoColContainerProps) {
    return (
        <table {...attr} className={joinNames(css.table, className)}>
            <tbody>{children}</tbody>
        </table>
    );
}

type TwoColRowProps = {
    left: ReactNode;
    right: ReactNode;
    type?: 'data-row' | 'heading-row' | 'heading-data-row';
    align?: 'left' | 'right' | 'left-right' | 'right-left';
    rightClass?: string;
    leftClass?: string;
};

export function TwoColRow({ left, right, type = 'heading-data-row', leftClass, rightClass, align = 'left-right' }: TwoColRowProps) {
    leftClass = getClassName('left', leftClass, align);
    rightClass = getClassName('right', rightClass, align);
    switch (type) {
        case 'heading-data-row':
            return (
                <tr>
                    <th scope="row" className={leftClass}>
                        {left}
                    </th>
                    <td className={rightClass}>{right}</td>
                </tr>
            );

        case 'data-row':
            return (
                <tr>
                    <td className={leftClass}>{left}:</td>
                    <td className={rightClass}>{right}</td>
                </tr>
            );

        case 'heading-row':
            return (
                <tr>
                    <th className={leftClass} scope="col">
                        {left}
                    </th>
                    <th className={rightClass} scope="col">
                        {right}
                    </th>
                </tr>
            );

        default:
            return null;
    }
}

export function SpacerRow() {
    return (
        <tr>
            <td>&nbsp;</td>
        </tr>
    );
}

function getClassName(loc: 'left' | 'right', base: string | undefined, align: TwoColRowProps['align']) {
    if (loc == 'left') {
        return joinNames(base, align == 'right' || align == 'right-left' ? css.alignRight : undefined);
    } else {
        return joinNames(base, align == 'right' || align == 'left-right' ? css.alignRight : undefined);
    }
}

type TwoColSpanProps = React.PropsWithChildren & {
    className?: string;
    align?: 'left' | 'right' | 'center';
};

export function TwoColSpan({ children, align = 'left', className, ...attr }: TwoColSpanProps) {
    className = align != 'left' ? (align == 'right' ? joinNames(className, css.alignRight) : joinNames(className, css.alignCenter)) : className;
    return (
        <tr>
            <td colSpan={2} {...attr} className={className}>
                {children ? children : <>&nbsp;</>}
            </td>
        </tr>
    );
}

export default TwoColContainer;
